var MuiCardMedia = {
    /* your custom class style overrides here */
    root: {
        height: 0,
        paddingTop: '56.25%', // 16:9 aspect ratio hack
    },
};
export default MuiCardMedia;
//# sourceMappingURL=MuiCardMedia.js.map